import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { Section } from "@atoms/Section";
import { WideCard } from "@atoms/WideCard";
import { formattedDate } from "@helpers/dateTime";
import { withTranslation } from "next-i18next";

const ContentPartial: React.FC<any> = ({ insightList }) => {
  const renderSections = () => {
    if (!insightList?.data) {
      return;
    }

    const sectionData = insightList?.data;

    const firstSection = (
      <Section maxWidth="full-width" pb={0} pt={0}>
        <Container maxWidth="lg" style={{ paddingLeft: 16, paddingRight: 16 }}>
          <Grid container spacing={3} style={{ minHeight: "110vh" }}>
            <Grid item xs={12} md={6}>
              {sectionData.map((item: any) => (
                <WideCard
                  key={item.id}
                  date={formattedDate(item.date)}
                  description={item.story}
                  title={item.title}
                  image={item.imageUrl.mediaPath}
                  linkTo={`/insight/${item.slug}`}
                  subtitle={item.category}
                  type="border"
                  isGlobalSearch
                />
              ))}
            </Grid>
          </Grid>
        </Container>
      </Section>
    );

    return (
      <Box bgcolor="white" pt={2} sx={{ minHeight: "calc(100vh - 56px)", overflow: "auto" }}>
        {firstSection}
      </Box>
    );
  };

  return <>{renderSections()}</>;
};

export default withTranslation("common")(ContentPartial);
